// extracted by mini-css-extract-plugin
export default {"liveIcon":"DlY76bOzCZIc4PJ5CAks"};